import React, { forwardRef } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { cn } from '../../../utils/cn';

/** Toolbar "Filters" button with an active-count badge. */
const FilterButton = forwardRef(({ count = 0, open, onClick }, ref) => (
    <button
        ref={ref}
        type="button"
        onClick={onClick}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label={count > 0 ? `Filters, ${count} applied` : 'Filters'}
        className={cn(
            'inline-flex h-9 items-center gap-1.5 rounded-md border px-3 text-sm font-medium shadow-sm outline-none focus-visible:ring-2 focus-visible:ring-primary-200',
            count > 0
                ? 'border-primary-200 bg-primary-50 text-primary-800 hover:bg-primary-100'
                : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50'
        )}
    >
        <SlidersHorizontal className="h-4 w-4" aria-hidden="true" />
        Filters
        {count > 0 && (
            <span
                aria-hidden="true"
                className="ml-0.5 grid h-5 min-w-[1.25rem] place-content-center rounded-full bg-primary-600 px-1 text-xs font-semibold tabular-nums text-white"
            >
                {count}
            </span>
        )}
    </button>
));

FilterButton.displayName = 'FilterButton';

export default FilterButton;
